import React from 'react';
import { useTranslation } from 'react-i18next';
import './SortCodeUsageModal.css';

const SortCodeUsageModal = ({ direction, isOpen, onClose, sortCodeId, sortCodeName, usageDetails, totalCount }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="usage-modal-overlay" onClick={onClose}>
            <div className="usage-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="usage-modal-content">
                    <div className="usage-modal-header">
                        <h2>{t('CannotDeleteSortCode')}</h2>
                    </div>

                    <div className="usage-modal-body">
                        <p className="usage-warning-text">
                            {t('SortCodeInUseMessage', { sortCodeId, sortCodeName })}
                        </p>
                        
                        <div style={{ direction: direction === 'ltr' ? 'ltr' : 'rtl' }} className="usage-details-section">
                            <h3>{t('UsageDetails')}</h3>
                            <div className="usage-stats">
                                <div className="usage-stat-item total">
                                    <span className="usage-stat-label">{t('TotalTransactions')}:</span>
                                    <span className="usage-stat-value">{totalCount}</span>
                                </div>
                                
                                {usageDetails && Object.entries(usageDetails).map(([type, count]) => (
                                    <div key={type} className="usage-stat-item">
                                        <span className="usage-stat-label">{t(type)}:</span>
                                        <span className="usage-stat-value">{count}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="usage-instruction">
                            <p>{t('DeleteSortCodeInstruction')}</p>
                        </div>
                    </div>

                    <div className="usage-modal-footer">
                        <button className="usage-close-button" onClick={onClose}>
                            {t('close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SortCodeUsageModal;

